import { useIntersectionObserver } from "hooks/use-intersection-observer";
import { useRef } from "react";

type IntersectWrapperProps = {
  className?: string;
  children: React.ReactNode;
};

export const IntersectWrapper = ({
  className,
  children,
}: IntersectWrapperProps) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const { isIntersecting } = useIntersectionObserver(ref);
  return (
    <div className={className} ref={ref}>
      {isIntersecting && children}
    </div>
  );
};
